import { Component, Input } from '@angular/core';

@Component({
    selector: 'pr-value',
    templateUrl: './pr-value.component.html',
    styleUrls: ['./pr-value.component.scss'],
    standalone: false
})
export class PrValueComponent {
  @Input() type: any;
  @Input() value: any;
  @Input() prefix: any;
  @Input() suffix: any;
}
